import { FC } from 'react';
import { PageMenuElement } from './element';
import { MenuConfig } from './index';

type Props = {
  elements: MenuConfig;
};

export const PageMenuElementList: FC<Props> = ({ elements }) => {
  return (
    <>
      {elements
        .filter((c) => !c.hidden)
        .map((element) => (
          <PageMenuElement key={element.title} {...element} />
        ))}
    </>
  );
};
